import { defineMessages } from 'react-intl';

export default defineMessages({
  more: {
    id: 'app.components.GlobalNav.MoreNavMenu.more',
    defaultMessage: 'More',
  },
});
